<template>
  <div>
    <div
      v-show="moduleName && JSON.stringify(moduleName) !== '{}'"
      ref="moduleNameContent"
      class="login-footer-ui-custom"
    >
      <span ref="moduleName"></span>
    </div>
    <div
      ref="footerContent"
      :class="nonsupportUiCustom ? 'login-footer-fixed' : 'login-footer-ui-custom'"
      v-show="nonsupportUiCustom || (footer && JSON.stringify(footer) !== '{}')"
    >
      <span ref="footer">

      </span>
    </div>
  </div>
</template>
<script>
import { UiConfigModule } from '../../store/modules/uiConfig'

export default {
  props: {
    /**
     * 暂时不支持UI自定义标志位
     *
     */
    nonsupportUiCustom: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    moduleName() {
      return UiConfigModule.moduleName
    },
    footer() {
      return UiConfigModule.footer
    }
  },
  watch: {
    moduleName: {
      deep: true,
      handler(nv) {
        if (Object.keys(nv) === 0) {
          return;
        }
        this.initUI(nv);
      }
    },
    footer: {
      deep: true,
      handler(nv) {
        if (Object.keys(nv) === 0) {
          return
        }
        this.initfooter(nv);
      }
    }
  },
  mounted() {
    if (this.nonsupportUiCustom) {
      const footer = this.$refs["footer"]
      footer.innerHTML = '北京来为科技股份有限公司 © 保留全部权利<br/>京ICP备 17069277号-1';
    }
  },
  methods: {
    initUI(config) {
      if (this.nonsupportUiCustom) {
        return;
      }
      const footer = this.$refs["moduleName"];
      const footerContent = this.$refs["moduleNameContent"];
      footer.innerHTML = config.copyrightContent;
      footer.style.backgroundColor = config.backgroundColor;
      footer.style.color = config.fontColor;
      footer.style.fontSize = config.fontSize + "px";
      footerContent.style.backgroundColor = config.containerColor;
      footer.style.lineHeight = config.lineHeight + 'px'
      footerContent.style.paddingTop = config.padding + 'px'
      footerContent.style.paddingBottom = config.padding + 'px'
    },
    initfooter(config) {
      if (this.nonsupportUiCustom) {
        return;
      }
      const footer = this.$refs["footer"];
      const footerContent = this.$refs["footerContent"];
      footer.innerHTML = config.copyrightContent;
      footer.style.backgroundColor = config.backgroundColor;
      footer.style.color = config.fontColor;
      footer.style.fontSize = config.fontSize + "px";
      footerContent.style.backgroundColor = config.containerColor;
      footer.style.lineHeight = config.lineHeight + 'px'
      footerContent.style.paddingTop = config.padding + 'px'
      footerContent.style.paddingBottom = config.padding + 'px'
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/index.scss";

.login-footer-fixed {
  width: 100%;
  background-color: #22365EFF;
  color: #B5B9C3FF;
  padding: computer(15px) 0 !important;
  line-height: computer(25px);
  text-align: center;
  font-size: computer(14px);
}

.login-footer-ui-custom {
  width: 100%;
  background-color: #f8f8f8;
  text-align: center;
}
</style>
